module.exports = __webpack_public_path__ + "4f3f0e4ff334de5387df7a3e97876833.svg";